// extracted by mini-css-extract-plugin
export default {"text":"Loading_text__qsqMz","bullets":"Loading_bullets__DLx4e","fade":"Loading_fade__KqaUc"};